import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: '950px',
    display: 'flex',
  },
  loading: {
    margin: '0 auto',
  },
}))

interface Props {
  color: 'primary' | 'secondary'
}

function LoadingIndicator({ color }: Props): JSX.Element {
  const classes = useStyles({})

  return (
    <div className={classes.root}>
      <CircularProgress color={color} className={classes.loading} />
    </div>
  )
}

export default LoadingIndicator
